import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Department, Ubication, Value, UploadDataResult, Vehicle, PagedList, DatatableRootObject, DataTablesResponse, Concessionaire } from '../interfaces/interfaces.index';
import { DeliveryType } from '../interfaces/delivery-type.interface';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { UploadFile } from '../shared/upload/upload.component';
const URL = `${URL_SERVICIOS}value`;

@Injectable({
  providedIn: 'root'
})

export class ValueService {

  constructor(private http: HttpClient) { }

  getValuesByType = (type: string) => this.http.get<Value[]>(`${URL}/type/${type}`);

  getValuesGroup = (types: string[]) => this.http.post<Value[]>(`${URL}/type`, JSON.stringify(types), HTTP_OPTIONS);

  getAllUbications = () => this.http.get<Department[]>(`${URL}/ubication`);

  getUbicationByCityId = (id) => this.http.get<Department>(`${URL}/ubication/${id}`);

  getUbication = (ubic: string) => {
     return this.http.get<Ubication>(`${URL}/ubication/${ubic}`).toPromise();
  }
  massiveVehicle = (file: UploadFile) => this.http.post<UploadDataResult>(`${URL}/vehicleFile`, file, HTTP_OPTIONS);

  getAllVehicles = () => this.http.get<Vehicle[]>(`${URL}/vehicles`);

  getValueById = (id: string) => this.http.get<Value>(`${URL}/${id}`);

  getValueIdByName = (name: string) => this.http.get<string>(`${URL}/name/${name}`);

  getValuesDataTable = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Value>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  createValue = (value: Value) => this.http.post<string>(URL, value, HTTP_OPTIONS);

  updateValue = (value: Value, id: string) => this.http.put<string>(`${URL}/${id}`, value, HTTP_OPTIONS);

  deleteValueById = (id: string) => this.http.delete(`${URL}/${id}`);

  getDeliveryTypes = () => this.http.get<DeliveryType[]>(`${URL}/delivery-types`);
}
